// StickNav.js
import React, { useState, useEffect, useRef } from 'react';
import StyledBox from 'views/rebranded-module/common/components/UI/StickNav/StickNav.styles';
import { Tabs, Tab } from '@mui/material';
import ScrollTo from 'lib/utils/ScrollTo';
import { sleep } from 'views/rebranded-module/common/utils/sleep';

const StickNav = (props) => {
  const {
    stickNavTabs,
    lazyLoading = false,
    className,
    lazyLoadingSleepTime,
  } = props;
  const [selectedTab, setSelectedTab] = useState(stickNavTabs[0]?.id);
  const tabBarRef = useRef(null);

  const [navItems, setNavItems] = useState(stickNavTabs);

  const handleTabChange = async (e, newVal) => {
    const tabBarHeight = tabBarRef.current?.offsetHeight;
    const currentTab = navItems.find((item) => item.id === newVal);

    if (lazyLoading && !currentTab.visited) {
      const nonVisitedTabs = navItems.filter((item) => !item.visited);
      const newNavItems = [...navItems];

      // eslint-disable-next-line no-restricted-syntax
      for (const item of nonVisitedTabs) {
        const newNavItem = navItems.find((navItem) => navItem.id === item.id);
        ScrollTo(item.id, -tabBarHeight);
        newNavItem.visited = true;
        // eslint-disable-next-line no-await-in-loop
        await sleep(lazyLoadingSleepTime || 600);
        if (item.id === newVal) {
          break;
        }
      }
      setNavItems(newNavItems);
    } else {
      ScrollTo(newVal, -tabBarHeight);
    }
  };

  const handleScroll = () => {
    const tabBarHeight = tabBarRef.current?.offsetHeight;
    const { scrollY } = window;
    const viewedSection = navItems.reduce((acc, tab) => {
      const element = document.getElementById(tab.id);
      return element && scrollY + tabBarHeight >= element.offsetTop - 2
        ? tab.id
        : acc;
    }, navItems[0]?.id);
    setSelectedTab(viewedSection);
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [stickNavTabs]);

  return (
    <StyledBox ref={tabBarRef} className={className}>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons={false}>
        {navItems.map((item) => (
          <Tab
            key={item.id}
            label={item.label}
            value={item.id}
            icon={item.icon || undefined}
            iconPosition={item.icon ? 'start' : undefined}
          />
        ))}
      </Tabs>
    </StyledBox>
  );
};
export { StickNav };
